import { useSelector } from 'react-redux';
import { getFilterParams } from '../ducks';

export const useGetFilterParams = () => ({
  filterParams: useSelector(getFilterParams),
});
